import React, { Component } from "react";
import {
  withStyles,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
} from "@material-ui/core";
import { blue, orange, red } from "@material-ui/core/colors";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import PreviewForm from "../View/PreviewForm";
import AlertDiv from "./AlertDiv";
import Loading from "./Loading";
import { GetData, PostData } from "../../../api/service";

const styles = (theme) => ({
  redStrip: {
    width: "100%",
    height: 8,
    backgroundColor: blue[400],
  },
});

// Registration fee for the PG courses (MA / MCOM) is collected over UPI against
// a QR code, with the student entering the transaction details afterwards. Every
// other course keeps paying through the online gateway (PaymentGo).
class ManualPaymentPagePG extends Component {
  state = {
    data: [],
    isLoaded: false,
    fees_list: [],
    isFeesLoaded: false,
    fees_id: "",
    amount_paid: "",
    transaction_id: "",
    date_of_payment: "",
    showQr: false,
    qrLink: "",
    error: "",
    errors: [],
  };

  componentDidMount() {
    GetData(`/${this.props.user.email}/admissionform/haspaymentdone`).then(
      (resp) => {
        if (!resp) {
          this.getInitialData();
        } else {
          this.props.history.replace("/final");
        }
      }
    );
  }

  getInitialData = () => {
    GetData(
      `/${this.props.user.email}/admissionform/getactivestudentsingle`
    ).then((resp) => {
      if (Array.isArray(resp) && resp.length > 0) {
        this.setState({
          data: resp[0],
          isLoaded: true,
        });

        PostData(`/getlistoffeesforadmission`, {
          course: resp[0].course,
          stream: resp[0].stream,
          semester: resp[0].semester,
          payment_type: "REGISTRATION_FEES",
        }).then((resp1) => {
          this.setState({
            fees_list: resp1,
            isFeesLoaded: true,
          });
        });

        PostData(`/validatepayment`, {
          shift: resp[0].shift,
          current_course: resp[0].course,
        })
          .then((resp2) => {
            if (resp2 && resp2.status == true) {
              this.setState({
                showQr: true,
                qrLink: resp2.data,
              });
            } else {
              this.setState({
                showQr: false,
                qrLink: "",
                error: "You cannot make the payment now. Kindly contact the office.",
              });
            }
          })
          .catch(() => {
            this.setState({
              showQr: false,
              qrLink: "",
              error: "You cannot make the payment now. Kindly contact the office.",
            });
          });
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  getFeeAmount = (fee_id) => {
    let fd = this.state.fees_list.find((el) => el.id == fee_id);
    if (fd) {
      return fd.payment_amount;
    } else {
      return "";
    }
  };

  validateUPITransactionNO = (trid) => {
    let reg = new RegExp("^[0-9]{12}$");
    return reg.test(trid);
  };

  handleValidation = () => {
    let { fees_id, amount_paid, transaction_id, date_of_payment } = this.state;
    let isValid = true;
    let errors = [];

    if (fees_id == "" || fees_id == null) {
      isValid = false;
      errors["fees_id"] = "Please fill up this field";
    } else {
      errors["fees_id"] = "";
    }

    if (amount_paid == "" || amount_paid == null) {
      isValid = false;
      errors["amount_paid"] = "Please fill up this field";
    } else {
      errors["amount_paid"] = "";
    }

    if (date_of_payment == "" || date_of_payment == null) {
      isValid = false;
      errors["date_of_payment"] = "Please fill up this field";
    } else {
      errors["date_of_payment"] = "";
    }

    if (!this.validateUPITransactionNO(transaction_id)) {
      isValid = false;
      errors["transaction_id"] =
        "Please put the 12 digit transaction id from your UPI app";
    } else {
      errors["transaction_id"] = "";
    }

    this.setState({ errors });

    return isValid;
  };

  onSubmit = () => {
    if (this.handleValidation()) {
      confirmAlert({
        title: "Final Submission",
        message:
          "After clicking the Final Submission button, you cannot change your form details.",
        buttons: [
          {
            label: "Final Submit",
            onClick: () => this.submitReceipt(),
          },
          {
            label: "Previous page",
          },
        ],
      });
    }
  };

  submitReceipt = () => {
    PostData(`/submitfeereceiptdata-re`, {
      form_id: this.state.data.form_id,
      transaction_id: this.state.transaction_id,
      amount_paid: this.state.amount_paid,
      fees_id: this.state.fees_id,
      date_of_payment: this.state.date_of_payment,
      applied_for_free: false,
    }).then((resp) => {
      alert(resp.message);
      if (resp.status == true) {
        window.location.reload();
      }
    });
  };

  render() {
    let { classes } = this.props;

    if (!this.state.isLoaded) {
      return <Loading />;
    }

    return (
      <div>
        {this.state.error != "" && (
          <AlertDiv border={red[300]} back={red[50]}>
            {this.state.error}
          </AlertDiv>
        )}

        <Card>
          <CardHeader
            title={`Registration Fee`}
            subheader={`Select the fee, scan the QR code and put the transaction details`}
          />
          <CardContent>
            <Grid container spacing={16}>
              <Grid item xs={12} sm={12} lg={12} md={12}>
                <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                  Select Fees <span className="red-alert">*</span>
                </Typography>

                {this.state.errors["fees_id"] ? (
                  <Typography variant="caption" style={{ color: "red" }}>
                    {this.state.errors["fees_id"]}
                  </Typography>
                ) : null}

                <select
                  className="form-control"
                  name="fees_id"
                  required
                  value={this.state.fees_id}
                  onChange={this.onChange}
                >
                  <option value="">-- Select --</option>
                  {Array.isArray(this.state.fees_list) &&
                    this.state.fees_list.map((el, index) => (
                      <option key={index} value={el.id}>
                        {el.payment_head} of Rs. {el.payment_amount}
                      </option>
                    ))}
                </select>

                {this.state.isFeesLoaded &&
                  Array.isArray(this.state.fees_list) &&
                  this.state.fees_list.length === 0 && (
                    <AlertDiv back={orange[100]} border={orange[400]}>
                      <Typography variant="subtitle2">
                        No registration fee has been set for this course yet.
                        Kindly contact the office.
                      </Typography>
                    </AlertDiv>
                  )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {this.state.showQr && this.state.fees_id != "" && (
          <Card>
            <CardHeader
              title={`Scan the QR and pay Rs. ${this.getFeeAmount(
                this.state.fees_id
              )}.`}
              subheader="Insert the transaction details after the payment"
            />
            <CardContent
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={this.state.qrLink}
                alt="Payment QR"
                style={{ width: "100%", height: 600, objectFit: "contain" }}
              />
            </CardContent>
          </Card>
        )}

        {this.state.showQr && this.state.fees_id != "" && (
          <Card>
            <CardContent>
              <Grid container spacing={16}>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <div>Amount Paid</div>
                  {this.state.errors["amount_paid"] ? (
                    <Typography variant="caption" style={{ color: "red" }}>
                      {this.state.errors["amount_paid"]}
                    </Typography>
                  ) : null}
                  <input
                    className="form-control"
                    placeholder="Amount Paid"
                    onChange={this.onChange}
                    value={this.state.amount_paid}
                    name="amount_paid"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <div>Transaction ID (as mentioned in the UPI app)</div>
                  {this.state.errors["transaction_id"] ? (
                    <Typography variant="caption" style={{ color: "red" }}>
                      {this.state.errors["transaction_id"]}
                    </Typography>
                  ) : null}
                  <input
                    className="form-control"
                    placeholder="Transaction ID"
                    onChange={this.onChange}
                    value={this.state.transaction_id}
                    name="transaction_id"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <div>Date of Payment</div>
                  {this.state.errors["date_of_payment"] ? (
                    <Typography variant="caption" style={{ color: "red" }}>
                      {this.state.errors["date_of_payment"]}
                    </Typography>
                  ) : null}
                  <input
                    type="date"
                    className="form-control"
                    onChange={this.onChange}
                    value={this.state.date_of_payment}
                    name="date_of_payment"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="button"
                      variant="contained"
                      size="small"
                      style={{ marginTop: 18 }}
                      onClick={this.props.back}
                    >
                      Previous Step
                    </Button>
                    &nbsp;
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginTop: 18 }}
                      onClick={() => this.onSubmit()}
                    >
                      Submit
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}

        <br />

        <PreviewForm user={this.props.user} />
      </div>
    );
  }
}

export default withStyles(styles)(ManualPaymentPagePG);
